































import Vue from 'vue';

export default Vue.extend({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    placement: {
      type: String,
      default: 'top-start',
    },
    popperClass: {
      type: String,
      default: 'link-insert-box',
    },
  },
  data() {
    return {
      text: '',
      link: '',
    };
  },
  methods: {
    confirmLinkInsert() {
      if (!/http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?/.test(this.link)) {
        this.$Message.error('请填写正确的链接');
      } else if (this.text === '') {
        this.$Message.error('请填写链接文字');
      } else {
        this.$emit('confirm', {
          text: this.text,
          link: this.link,
        });
        this.text = ''
        this.link = ''
      }
    },
  },
});
